import { Routes, Route, Navigate } from "react-router-dom";
import { AdminProvider, useAdmin } from "@/admin/AdminContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/pages/Overview";
import Users from "@/admin/pages/Users";
import Plans from "@/admin/pages/Plans";
import Logs from "@/admin/pages/Logs";
import SystemSettings from "@/admin/pages/SystemSettings";

function Guard({ children, perm }) {
  const { staff, can } = useAdmin();
  if (staff === null) return <div className="min-h-screen grid place-items-center label-xs" data-testid="admin-auth-loading">Loading admin portal…</div>;
  if (!staff) return <Navigate to="/admin/login" replace />;
  if (perm && !can(perm)) return <AdminLayout><p className="text-sm text-zinc-500" data-testid="admin-no-permission">Your role does not have access to this section.</p></AdminLayout>;
  return <AdminLayout>{children}</AdminLayout>;
}

export default function AdminApp() {
  return (
    <AdminProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route index element={<Guard><Overview /></Guard>} />
        <Route path="users" element={<Guard><Users /></Guard>} />
        <Route path="plans" element={<Guard perm="view_plans"><Plans /></Guard>} />
        <Route path="logs" element={<Guard><Logs /></Guard>} />
        <Route path="system" element={<Guard perm="system_settings"><SystemSettings /></Guard>} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminProvider>
  );
}
